<p> Tra le attività della De Cifris troviamo l'iniziativa PQCifris, che raccoglie
	i membri della De Cifris interessati alla cosìdetta Crittografia Post-Quantum o
	Crittografia Quantum-Safe. Si tratta di cifrari che sono progettati in modo da
	poter resistere anche a un attacco crittoanalitico eseguito da un computer quantistico. </p>
<p> L'obiettivo è creare una sinergia tra le diverse competenze presenti nell'iniziativa per
	contribuire sia agli aspetti di divulgazione e formazione, sia agli aspetti di ricerca e
	trasferimento tecnologico. </p>
<h5>Comitato organizzatore</h5>
<ul>
	<li>Cecilia Boschini, Technion;</li>
	<li>Marco Baldi, Università Politecnica delle Marche.</li>
</ul>
<p> Per aderire all'iniziativa contattare <a href="mailto:pqcifris@decifris.it">
		pqcifris&#64;decifris.it</a>. <br>
	Il coordinatore dell'iniziativa è Marco Baldi <a href="mailto:m.baldi@univpm.it">
		m.baldi&#64;univpm.it</a>. </p>

<h4>EVENTI</h4>

<ul>
	<li>
		<a routerLink="/attivita/pqcifris-summer22"> PQCifris 2022 </a>, evento organizzato, in sede, dal Dipartimento di
		Matematica di Trento e da De Componendis Cifris: 10-14 ottobre 2022.
	</li>
	<li>
		Primo evento tenuto presso la prestigiosa sede della CONSOB: 9 maggio 2019.
	</li>
	<li>
		Sessione dell'iniziativa De Componendis Cifris dentro ITASEC18: 8 febbraio 2018.
	</li>
</ul>

<h4>SEMINARI RECENTI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<ul>
	<li>
		<b>9 Giugno 2022 - 16:00</b>
		<ul>
			<li>
				<b>Edoardo Persichetti</b> -- Florida Atlantic University <br>
				<i>"Developing Innovative Frameworks for Efficient Code-based Signatures"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/06.2022-Persichetti (1).pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/Persichetti_9 giugno.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=RSIuTnuVpiA">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>7 Giugno 2022 - 14:00</b>
		<ul>
			<li>
				<b>Andrea Mari</b> -- Unitary Fund <br>
				<i>"Quantum computers in theory and in practice"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/05.2022-
									Mari.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/Allegato1_
									Slide_Mari.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=61bX0j8ov5s">Video</a>
			</li>
		</ul>
	</li>
</ul>

<h4>PROSSIMI SEMINARI</h4>
<ul>

</ul>

<h4>SEMINARI PASSATI</h4>
<ul>
	<li>
		<b>1 Dicembre - 11:30</b>
		<ul>
			<li>
				<b>Alessio Meneghetti</b> -- Università di Trento <br>
				<i>"On a link between Code-Based and Multivariate-Based Cryptosystems"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/
							12.2022-Meneghetti_Tognolini.pdf">Locandina</a>
			</li>
			<li>
				<b>Giovanni Tognolini</b> -- Università di Trento <br>
				<i>"Towards a Post Quantum OTS Scheme using QC-LDPC Codes"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/
							12.2022-Meneghetti_Tognolini.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/tognolini_slide.pdf">Slide</a>
			</li>
		</ul>
	</li>
	<li>
		<b>5 Aprile 2022 - 15:00</b>
		<ul>
			<li>
				<b>Shi Bai</b> -- Florida Atlantic University <br>
				<i>"Lattice algorithms for variants of LWE"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/04.2022-Shi
							Bai.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/Allegato2_
							PQCifris_ShiBai.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=lqsptSSR-wQ">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b> 1 Febbraio 2022</b>
		<ul>
			<li>
				<b>Edoardo Persichetti</b> -- Florida Atlantic University (US) <br>
				<i>"Code-based Signatures: New Approaches and Research Directions"</i> <br>
				<a href="../../../assets/attivita/gruppi/PQCifris/Persichetti
							Locandina.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/Persichetti
							Slide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=5mTf4XNNRrQ">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>7 Dicembre 2021</b>
		<ul>
			<li>
				<b>Cecilia Boschini</b> -- Technion‌<br>
				<i>"How to do Efficient Signature Verification without Leakage"</i><br>
				<a href=".././../../assets/attivita/gruppi/PQCifris/12.2021_Boschini.pdf">Locandina</a> --
				<a href=".././../../assets/attivita/gruppi/PQCifris/Boschini.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=L1USfpbSvgo">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>2 Novembre 2021</b>
		<ul>
			<li>
				<b>Paolo Santini</b> -- Università‌ ‌Politecnica‌ ‌delle‌ ‌Marche<br>
				<i>" Recent advances in code-based encryption and digital signatures"</i><br>
				<a href="../../../assets/attivita/gruppi/PQCifris/11.2021_Santini.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/11.2021-SantiniSlide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=KBTKdT4IP84&t=6s">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		Seminario online tenuto da Andrea Basso: Saber: a Post-Quantum Lattice-Based Protocol - 24 agosto 2020
		( <a href="https://youtu.be/s2PJrtgUZLU">Video</a> ).
	</li>
</ul>
<h4>SEMINARI AFFINI</h4>
<ul>
	<li>
		<b>14 Dicembre 2020</b> (<a routerLink="/decifris-scholalatina">De Cifris Schola Latina</a>)
		<ul>
			<li>
				<b>Edoardo Persichetti</b> -- Florida Atlantic University <br>
				<i>Code-based Cryptography and Post-Quantum Standardization</i><br>
				<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/14.12.2020-Persichetti.pdf">
					Locandina</a> --
				<a href="../../../../assets/attivita/seminariLocali/deCifrisScholaLatina/slide_Persichetti.pdf">
					Slide</a> --
				<a href="https://www.youtube.com/watch?v=UNwxzwBzl2w">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>5 Maggio 2021 </b> (<a routerLink="/mathCifris">Math Cifris</a>)
		<ul>
			<li>
				<b>Luca de Feo</b> -- Université de Versailles – Saint-Quentin e IBM Zurich <br>
				<i>"La corrispondenza di Deuring effettiva – la chiave per la prossima
					generazione di crittografia basata sulle isogenie?"</i> <br>
				<a href="../../../assets/attivita/gruppi/mathCifris/DeFeo.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/mathCifris/DeFeoSlide.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=Ktp1VVuuM9U">Video</a>
			</li>
		</ul>
	</li>
	<li>
		<b>20 Maggio 2021</b> (<a routerLink="/decifris-athesis">De Cifris Athesis</a>)
		<ul>
			<li>
				<b>Annamaria Iezzi</b> -- Université de la Polynésie Française. <br>
				<i>"Strumenti per fare crittoanalisi nei grafi di isogenie supersingolari"</i><br>
				<a href="../../../assets/attivita/seminariLocali/deCifrisAthesis/Iezzi.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifrisAthesis/IezziIsogeny.pdf">Slide</a> --
				<a href="https://youtu.be/b9YU-UNgVSs">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>8 Aprile 2021</b> (<a routerLink="/mathcifris">Math Cifris</a>)
		<ul>
			<li>
				<b>Emmanuela Orsini, </b> -- COSIC, KU Leuven <br>
				<i>"Post-quantum secure oblivious transfer"</i>.<br>
				<a href="../../../assets/attivita/gruppi/mathCifris/Orsini.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/PQCifris/OrsiniSlide.pdf">Slide</a> --
				<a href="https://youtu.be/A54aJqzFRYM">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>5 Febbraio 2021</b> (<a routerLink="/decifris-augustaetaurinorum">
			De Cifris Augustae Taurinorum</a>)
		<ul>
			<li>
				<b>Carlo Sanna</b> -- Politecnico di Torino <br>
				<i>Introduction to Multivariate Cryptography</i><br>
				<a
					href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/locandina_Sanna.pdf">Locandina</a>
				--
				<a
					href="../../../../assets/attivita/seminariLocali/deCifrisAugustaeTaurinorum/Sanna_Intro_MVC.pdf">Slide</a>
				--
				<a href="https://youtu.be/v5su7blRrHk">Video</a>
				<br>
			</li>
		</ul>
	</li>
</ul>

<h4>VIDEO</h4>
<p>I video di crittografia Post-Quantum disponibili sul nostro <a href="https://www.youtube.com/watch?v
						=c16aoAi-7Bo&list=PLu4yxTVzRRMU93T5hf2mKtVINipn5O69F">canale YouTube.</a></p>